import "./assets/js/nav-pills.js";
import "./assets/scss/theme.scss";

export default {
  install() { },
};
